module.exports = __webpack_public_path__ + "img/small_waiting.b5800a36.svg";